export const caretrackSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": "https://scienzahealth.com/caretrack#product",
  "name": "CareTrackAI Post-Surgical Care Platform",
  "description": "AI-powered post-surgical care monitoring system for cardiac and orthopedic recovery, transforming patient care with continuous physical and cognitive health tracking.",
  "brand": {
    "@type": "Brand",
    "name": "Scienza Health"
  },
  "category": "Healthcare Software",
  "applicationCategory": "Healthcare",
  "operatingSystem": "Web-based",
  "offers": {
    "@type": "Offer",
    "availability": "https://schema.org/InStock",
    "price": "Contact for Pricing",
    "priceCurrency": "USD"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "156"
  },
  "featureList": [
    "Real-time Patient Monitoring",
    "AI-Powered Health Analytics",
    "Cognitive Health Assessment",
    "Care Team Collaboration",
    "Early Risk Detection"
  ],
  "potentialAction": {
    "@type": "ViewAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://scienzahealth.com/caretrack/how-it-works",
      "actionPlatform": [
        "http://schema.org/DesktopWebPlatform",
        "http://schema.org/MobileWebPlatform"
      ]
    }
  },
  "isAccessibleForFree": false,
  "keywords": [
    "post-surgical care",
    "patient monitoring",
    "healthcare AI",
    "cardiac recovery",
    "orthopedic recovery",
    "cognitive health",
    "medical monitoring",
    "healthcare technology"
  ]
};